<template>
    <CompassModal
        v-model:visible="showModal"
        size="small"
        :title="
            $t.__('listing.batchComponents.EditRecurringServicePeriodComponent.title')
        "
        class="edit-recurring-service-period-component"
        @closed="close"
    >
        <template #header>
            <div class="dialog__header">
                <div class="dialog__header--title"></div>
                <div class="dialog__header--close">
                    <CompassIconButton icon="close" @click="$emit('close')" />
                </div>
            </div>
        </template>
        <template #default>
            <div class="dialog__default">
                <p>
                    {{
                        $l10n.__(
                            'Seules les dates de service seront modifiées ; vos occurrences actuelles et futures ne seront pas affectées.',
                        )
                    }}
                </p>
                <div class="dialog__form">
                    <CompassFormItem :label="$l10n.__('Dates de début service')">
                        <div class="input-select-date-activity__range">
                            <CompassDatePicker
                                v-model="dateStart"
                                :calendarOptions="{ lang: uiLang }"
                                :formatDateDisplayed="formatDateDisplayed"
                            />
                        </div>
                    </CompassFormItem>
                    <CompassFormItem :label="$l10n.__('Dates de fin de service')">
                        <div class="input-select-date-activity__range">
                            <CompassDatePicker
                                v-model="dateStop"
                                :calendarOptions="{ lang: uiLang }"
                                :formatDateDisplayed="formatDateDisplayed"
                            />
                        </div>
                    </CompassFormItem>
                </div>
            </div>
        </template>
        <template #footer>
            <div class="dialog__footer">
                <CompassButton
                    :label="$t.__('common.actions.cancel')"
                    type="secondary"
                    @click="close()"
                />
                <CompassButton
                    :label="$t.__('common.actions.confirm')"
                    type="primary"
                    class="ml-3"
                    @click="save"
                    :disabled="loading"
                />
            </div>
        </template>
    </CompassModal>
</template>

<script>
import { ListingEvent } from 'js/types/events';
import { createNamespacedHelpers } from 'vuex';

const { mapState: corpMapState } = createNamespacedHelpers('corp');

export default {
    props: {
        rows: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            showModal: true,
            loading: false,
            dateStart: '',
            dateStop: '',
        };
    },
    computed: {
        ...corpMapState(['uiLang', 'timeformat']),
        formatDateDisplayed() {
            return this.timeformat === 'dmy' ? 'DD/MM/YYYY' : 'MM/DD/YYYY';
        },
    },
    methods: {
        save() {
            if (this.dateStart === '' && this.dateStop === '') {
                Push.error(this.$l10n.__('Au moins une des dates doit être renseignée.'));
                return;
            }
            if (this.dateStart && this.dateStop && this.dateStart > this.dateStop) {
                Push.error(this.$l10n.__('La date de début doit être antérieure à la date de fin.'));
                return;
            }
            this.loading = true;
            this.$ajax.post(
                `/recurrings/service-period/update`,
                {},
                { recIds: this.rows, dateStart: this.dateStart, dateStop: this.dateStop },
                () => {
                    this.loading = false;
                    Push.success(this.$l10n.__('Les dates de début et de fin service ont bien été mises à jour'));
                    this.close();
                    EventBus.emit(ListingEvent.REFRESH);
                },
                (event) => {
                    this.loading = false;
                    this.close();
                    const errorMessage = event?.response?.data?.message ?? this.$l10n.__('Une erreur est survenue lors de la mise à jour des dates de début et de fin service');
                    Push.error(errorMessage);
                },
            );
        },
        close() {
            this.$emit('close');
        },
    },
};
</script>

<style lang="scss">
.edit-recurring-service-period-component {
    .dialog {
        &__header {
            display: flex;
            justify-content: space-between;
            padding: 24px 32px;

            &--title {
                display: flex;
                flex-direction: column;
            }

            &--close {
                display: flex;
                justify-content: flex-end;
                align-items: flex-start;
            }
        }

        &__default {
            padding-bottom: 24px;
            p {
                margin: 0 0 var(--spacing-3);
            }
            .dialog__form {
                display: flex;
                flex-direction: column;
                gap: var(--spacing-3);
                .input-select-date-activity__range {
                    .compass-input {
                        min-width: 250px;
                        width: 250px;
                    }
                }
            }
        }

        &__footer {
            display: flex;
            justify-content: flex-end;
            padding: 0 32px 24px 32px;
        }
    }
}
</style>
